let lockCount = 0;
let savedScrollY = 0;
let savedScrollX = 0;
let savedScrollbarCompensation = 0;
let savedRootScrollBehavior = '';

const getScrollbarCompensation = () => {
  const root = document.documentElement;

  return Math.max(0, window.innerWidth - root.clientWidth);
};

export const lockBodyScroll = () => {
  if (lockCount === 0) {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    savedScrollX = window.scrollX || window.pageXOffset || 0;
    savedScrollbarCompensation = getScrollbarCompensation();

    document.body.style.setProperty('--scroll-lock-top', `-${savedScrollY}px`);
    document.body.style.setProperty(
      '--scroll-lock-scrollbar-compensation',
      `${savedScrollbarCompensation}px`
    );
  }

  lockCount += 1;
  document.body.classList.add('menu-open');
};

export const unlockBodyScroll = () => {
  lockCount = Math.max(0, lockCount - 1);

  if (lockCount === 0) {
    const root = document.documentElement;

    savedRootScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    document.body.classList.remove('menu-open');
    document.body.style.removeProperty('--scroll-lock-top');
    document.body.style.removeProperty('--scroll-lock-scrollbar-compensation');

    window.scrollTo(savedScrollX, savedScrollY);

    window.requestAnimationFrame(() => {
      root.style.scrollBehavior = savedRootScrollBehavior;
    });
  }
};
